<template>
  <div class="list-item-action p-3">
    <div class="row">
      <div
        class="col-1 d-none d-sm-block list-item-action--icon list-item--icon"
      >
        <i :class="getListItemClass()" aria-hidden="true"></i>
      </div>
      <div class="col list-item-action--content">
        <div class="list-item-action--content-title" v-text="title" />
        <div class="list-item-action--content-subtitle" v-text="subtitle" />
      </div>
      <div class="col-sm-12 col-md-6 col-lg-4 mt-3 mt-md-0">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "mdi-circle-outline"
    },
    title: {
      type: String,
      default: "title"
    },
    subtitle: {
      type: String,
      default: "subtitle"
    }
  },
  methods: {
    getListItemClass() {
      return `fa fa-${this.icon}`;
    }
  }
};
</script>
